import Button from "@mui/material/Button";
import { isPositiveNumber } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import getCorePopUpStore from "../../../../../../stores/core/core-popup-store";
import getKhattabat102Store from "../../../../../../stores/khattabat-stores/102-stores";
import getKhattabat102GeneralStore from "../../../../../../stores/khattabat-stores/102-stores/general-102-store";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const KhattabatReactivateConversation = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { conversationID } = props;
  const conversationType =
    getKhattabatSharedMessagingStore(conversationID).conversationType.get();
  const { exitByMatch, exitByUser, isMatchInAnotherOngoingOneOTwo } =
    getKhattabat102Store(conversationID);

  const isConversationExitExists =
    isPositiveNumber(exitByUser.get()) || isPositiveNumber(exitByMatch.get());
  const isReactivateBlocked =
    isConversationExitExists && isMatchInAnotherOngoingOneOTwo.get();

  return conversationType !== "102" ? null : (
    <Button
      variant="contained"
      color={isReactivateBlocked ? "inherit" : "success"}
      disabled={!isConversationExitExists}
      onClick={() => {
        if (isReactivateBlocked) {
          getCorePopUpStore().showAlertMessage(
            "ONE_O_TWO_MATCH_IS_IN_ANOTHER_ONGOING_ONE_O_TWO"
          );
          return;
        }
        getKhattabat102GeneralStore().setReactivateOneOTwoConversation(
          conversationID
        );
        getCorePopUpStore().openConfirmationPopUps(
          "ONE_O_TWO_CONFIRMATION_POPUP"
        );
      }}
    >
      {i18n.get("REACTIVATE")}
    </Button>
  );
});

export default KhattabatReactivateConversation;
